import React, { useState, useEffect, useContext } from "react";
import Quilleditor from "../../Quilleditor/Quilleditor";
import { useTranslation } from "react-i18next";
import ResumeUseForm from "../../../hooks/editor/resumeUseForm";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import EditorInput from "../../Inputs/EditorInput";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";

function AchievementItem(props) {
  const [t, i18n] = useTranslation("common");

  return (
    <>
      <div className="col-md-12 mb-3">
        <div className="mr-2 mb-3">
          {!props.showPopup && (
            <img
              src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
              alt="trash"
              className="ml-1 delete_icon float-right"
              onClick={props.handleItemDelete}
            />
          )}
        </div>
        {props &&
          props.res &&
          props.res.showFields &&
          props.res.showFields.name && (
            <EditorInput
              label={t(`achievements.award`)}
              value={props.res.name}
              name="name"
              autoComplete="off"
              className={`form-control  ${props.sectionId}focus${props.index}`}
              onChange={props.resumeHandler}
              onBlur={props.resumeUpdate}
            />
          )}
      </div>
      {props &&
        props.res &&
        props.res.showFields &&
        props.res.showFields.description && (
          <div className="col-md-12">
            <label>{t(`achievements.description`)}</label>
            <Quilleditor
              type="basic"
              theme={"snow"}
              inivalue={
                props?.res?.description
                  ? props?.res?.description.replace(/\n|\r/g, "")
                  : ""
              }
              className={`${props.sectionId}focus${props.index}`}
              current={props.index}
              id={props.sectionId}
              sectionId={props.sectionId}
              placeholder="Whats the one thing that you want someone to remember to after reading your resume?"
              setvalue={props.handleEditorChange}
              onBlur={props.resumeUpdate}
              handleSuggestion={props.handleSuggestion}
            />
            {/* <div className={props.showPopup ? "mb-1 mt-3 d-flex" : "mb-1 d-flex"}>
          <ResumeButton
            success
            alt="plus"
            title="Save"
            className="mr-2"
            onClick={() => props.resumeUpdate()}
          />
          <ResumeButton
            white
            alt="plus"
            title="Cancel"
            onClick={props.resumeUpdateCancel}
          />
        </div> */}
          </div>
        )}
    </>
  );
}

export default AchievementItem;
